
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/changelog/power-design.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/changelog/power-design.md?type=demo')
};